import {
  DISPATCH_BOARD_LIST_REQUEST,
  DISPATCH_BOARD_LIST_SUCCESS,
  DISPATCH_BOARD_LIST_FAIL,
  DISPATCH_BOARD_DATA_REQUEST,
  DISPATCH_BOARD_DATA_SUCCESS,
  DISPATCH_BOARD_DATA_FAIL,
  DISPATCH_BOARD_CREATE_REQUEST,
  DISPATCH_BOARD_CREATE_SUCCESS,
  DISPATCH_BOARD_CREATE_FAIL,
  DISPATCH_BOARD_UPDATE_REQUEST,
  DISPATCH_BOARD_UPDATE_SUCCESS,
  DISPATCH_BOARD_UPDATE_FAIL,
  DISPATCH_BOARD_DELETE_REQUEST,
  DISPATCH_BOARD_DELETE_SUCCESS,
  DISPATCH_BOARD_DELETE_FAIL,
} from "./actionType";

export const listDispatchBoards = (data) => ({ type: DISPATCH_BOARD_LIST_REQUEST, payload: data });
export const listDispatchBoardsSuccess = (data) => ({ type: DISPATCH_BOARD_LIST_SUCCESS, payload: data });
export const listDispatchBoardsFail = (error) => ({ type: DISPATCH_BOARD_LIST_FAIL, payload: error });

export const getDispatchBoard = (data) => ({ type: DISPATCH_BOARD_DATA_REQUEST, payload: data });
export const getDispatchBoardSuccess = (data) => ({ type: DISPATCH_BOARD_DATA_SUCCESS, payload: data });
export const getDispatchBoardFail = (error) => ({ type: DISPATCH_BOARD_DATA_FAIL, payload: error });

export const createDispatchBoard = (data) => ({ type: DISPATCH_BOARD_CREATE_REQUEST, payload: data });
export const createDispatchBoardSuccess = (data) => ({ type: DISPATCH_BOARD_CREATE_SUCCESS, payload: data });
export const createDispatchBoardFail = (error) => ({ type: DISPATCH_BOARD_CREATE_FAIL, payload: error });

export const updateDispatchBoard = (data) => ({ type: DISPATCH_BOARD_UPDATE_REQUEST, payload: data });
export const updateDispatchBoardSuccess = (data) => ({ type: DISPATCH_BOARD_UPDATE_SUCCESS, payload: data });
export const updateDispatchBoardFail = (error) => ({ type: DISPATCH_BOARD_UPDATE_FAIL, payload: error });

export const deleteDispatchBoard = (data) => ({ type: DISPATCH_BOARD_DELETE_REQUEST, payload: data });
export const deleteDispatchBoardSuccess = (data) => ({ type: DISPATCH_BOARD_DELETE_SUCCESS, payload: data });
export const deleteDispatchBoardFail = (error) => ({ type: DISPATCH_BOARD_DELETE_FAIL, payload: error });
